interface StoredExtraFields {
    data: Record<string, string>
    timestamp: number
}

const STORAGE_KEY_PREFIX = 'extraFields_'
const EXPIRATION_TIME = 20 * 60 * 1000 // 20 минут в миллисекундах

export const saveFieldValueToStorage = (paymentPageId: string, key: string, value: string): void => {
    try {
        const data = loadExtraFieldsFromStorage(paymentPageId)

        data[key] = value

        localStorage.setItem(storageKey(paymentPageId), JSON.stringify({ data, timestamp: Date.now() }))
    } catch (error) {
        console.error('Failed to save extra fields to localStorage:', error)
    }
}

export const loadExtraFieldsFromStorage = (paymentPageId: string): Record<string, string> => {
    try {
        const storedItem = localStorage.getItem(storageKey(paymentPageId))

        if (!storedItem) {
            return {}
        }

        const storageData: StoredExtraFields = JSON.parse(storedItem)

        if (Date.now() - storageData.timestamp > EXPIRATION_TIME) {
            localStorage.removeItem(storageKey(paymentPageId))

            return {}
        }

        return storageData.data
    } catch (error) {
        console.error('Failed to load extra fields from localStorage:', error)

        return {}
    }
}

export const clearExtraFieldsFromStorage = (paymentPageId: string): void => {
    try {
        localStorage.removeItem(storageKey(paymentPageId))
    } catch (error) {
        console.error('Failed to clear extra fields from localStorage: ', error)
    }
}

const storageKey = (paymentPageId: string): string => `${STORAGE_KEY_PREFIX}${paymentPageId}`
